import API from './api'

const {REACT_APP_API_URI} = process.env;


class ManagerVersionApi {
    constructor(token) {
        this.api = new API(token);
        this.baseUrl = `${REACT_APP_API_URI}/admin/manager-version`
    }
    get() {
        try{
            return this.api.get(`${this.baseUrl}`)
            .then((response) => {
                return response.data.data;
            });
        }catch(error) {
            console.error(`Error getting manager version, error=${error}`);
            return {}
        }
    }
    create(body) {
        try{
            return this.api.post(`${this.baseUrl}`, body)
            .then((response) => {
                return response;
            });
        }catch(error) {
            console.error(`Error creating manager version, error=${error}`);
            return {}
        }
    }
    update(id, body) {
        try{
            return this.api.patch(`${this.baseUrl}/${id}`, body)
            .then((response) => {
                return response;
            });
        }catch(error) {
            console.error(`Error updating manager version, error=${error}`);
            return {}
        }
    }
  
}

export default ManagerVersionApi;